import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { BaseSettingsSectionComponent } from "../base-settings-section.component";
import { ExtensionSettingsService } from "../extension-settings.service";

@Component({
    selector: "app-flycut-timeout-settings",
    templateUrl: "./flycut-timeout-settings.component.html",
    styleUrls: ["./flycut-timeout-settings.component.scss"],
    standalone: false
})
export class FlycutTimeoutSettingsComponent extends BaseSettingsSectionComponent implements OnInit, OnChanges {
  @Input() initialTimeout = 5000;

  private lastSavedTimeout: number;

  constructor(
    private readonly fb: FormBuilder,
    private readonly settingsService: ExtensionSettingsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.lastSavedTimeout = this.initialTimeout;
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialTimeout && !changes.initialTimeout.firstChange) {
      this.lastSavedTimeout = changes.initialTimeout.currentValue;
      if (this.form) {
        this.form.patchValue({ timeout: this.lastSavedTimeout }, { emitEvent: false });
        this.markPristine();
      }
    }
  }

  buildForm(): FormGroup {
    return this.fb.group({
      timeout: [this.initialTimeout],
    });
  }

  getSaveObservable(): Observable<any> {
    const { timeout } = this.form.value;
    this.lastSavedTimeout = timeout;
    return this.settingsService.saveTimeout(timeout, false);
  }

  resetToLastSaved(): void {
    this.form.patchValue({ timeout: this.lastSavedTimeout }, { emitEvent: false });
  }

  setDefault(): void {
    this.form.patchValue({ timeout: 5000 });
    this.settingsService.saveTimeout(5000, true).subscribe(() => {
      this.lastSavedTimeout = 5000;
      this.markPristine();
    });
  }

  get timeout(): number {
    return this.form?.get("timeout")?.value;
  }
}
